<template>
  <div class="news-grid common-width">
    <div class="news-item" v-for="newsItem in newsItems" @click="newItemClick(newsItem)">
      <!--    <div class="news-pic" :style="background-image?:"></div>-->
      <img class="news-pic" :src="require(`@/assets/images/${newsItem.imgSrc}`)" />
      <div class="news-item-text" v-text="newsItem.time" />
      <div class="news-item-text" v-text="newsItem.title" />
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
export default {
  name: "NewsItemsView",
  props: {
    newsItems:{
      type: Array,
      default: [
        {
          imgSrc: "",
          time: "",
          title: ""
        }
      ]
    }
  },
  setup(){
    const router = useRouter()
    function newItemClick(newsItem){
      router.push({ name: "NewsDetailPage", params: { id: newsItem.id } });
    }
    return{
      newItemClick,
    }
  }
};
</script>

<style scoped>

.news-grid{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.news-item {
  display: flex;
  flex-direction: column;
  width: 380px;
  cursor: pointer;
}
.news-item:nth-child(n+4){
  margin-top: 46px;
}

.news-pic {
  width: 380px;
  height: 280px;
}

.news-item-text {
  font-size: 20px;
  color: #666666;
  line-height: 40px;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>
